import ServiceBase from './ServiceBase';

export default class PushNotificationsService extends ServiceBase {
    enablePushNotifications(deviceToken) {
        return this.request('post', 'pushNotifications/enablePushNotifications', { deviceToken });
    }
}